<template>
  <b-modal :active="active" has-modal-card :can-cancel="false" trap-focus>
    <div class="modal-card terms-modal">
      <header class="modal-card-head terms-header">
        <span class="terms-icon" aria-hidden="true">≡</span>
        <div>
          <span class="terms-eyebrow">Antes de comenzar</span>
          <h2 id="terms-title" class="modal-card-title">{{ term.title || 'Términos y condiciones' }}</h2>
          <p>Lee la información antes de continuar con la encuesta.</p>
        </div>
      </header>

      <section class="modal-card-body terms-body" aria-labelledby="terms-title">
        <div class="terms-document content" v-html="term.message"></div>
      </section>

      <footer class="modal-card-foot terms-footer">
        <p>Al continuar, aceptas las condiciones indicadas y podrás responder la encuesta.</p>
        <div class="terms-actions">
          <button class="button terms-back" type="button" @click="$emit('decline')">Volver</button>
          <button class="button terms-accept" type="button" @click="$emit('accept')">
            Acepto y continuar <span aria-hidden="true">→</span>
          </button>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "TermsConsent",
  props: {
    active: { type: Boolean, required: true },
    term: { type: Object, required: true },
  },
};
</script>

<style scoped>
.terms-modal { width: min(94vw, 720px); max-height: calc(100vh - 3rem); border-radius: 16px; overflow: hidden; }
.terms-header { display: flex; align-items: flex-start; gap: 1rem; padding: 1.5rem 1.8rem; background: linear-gradient(115deg, #194f58, #0e786f); border: 0; }
.terms-icon { display: grid; flex: none; place-items: center; width: 2.7rem; height: 2.7rem; border: 1px solid rgba(255,255,255,.4); border-radius: 10px; background: rgba(255,255,255,.14); color: white; font-size: 1.45rem; }
.terms-eyebrow { color: #c1f0df; font-size: .75rem; font-weight: 800; letter-spacing: .12em; text-transform: uppercase; }
.terms-header .modal-card-title { margin: .25rem 0 .4rem; color: white; font-size: clamp(1.3rem, 3vw, 1.75rem); font-weight: 700; line-height: 1.25; white-space: normal; }
.terms-header p { color: #e2f5f0; font-size: .9rem; }
.terms-body { padding: 1.5rem 1.8rem; background: #f6faf8; }
.terms-document { padding: clamp(1.2rem, 3vw, 2rem); border: 1px solid #e3ebe8; border-radius: 12px; background: white; color: #304d53; line-height: 1.7; overflow-wrap: anywhere; box-shadow: 0 5px 20px rgba(27, 73, 69, .04); }
.terms-footer { display: flex; align-items: center; justify-content: space-between; gap: 1rem; padding: 1rem 1.8rem; background: white; }
.terms-footer p { max-width: 21rem; color: #687e80; font-size: .8rem; line-height: 1.45; }
.terms-actions { display: flex; flex: none; gap: .6rem; }
.terms-actions .button { min-height: 2.7rem; border-radius: 8px; font-weight: 700; }
.terms-back { border-color: #d7e5e1; color: #3f676b; }
.terms-accept { border: 0; background: #087b72; color: white; }
.terms-accept:hover, .terms-accept:focus { background: #06645d; color: white; }
.terms-accept span { margin-left: .4rem; }
@media (max-width: 620px) {
  .terms-header, .terms-body, .terms-footer { padding: 1rem; }
  .terms-header { gap: .7rem; }
  .terms-footer { align-items: stretch; flex-direction: column; }
  .terms-actions { display: grid; grid-template-columns: 1fr 1fr; }
  .terms-actions .button { height: auto; white-space: normal; }
}
</style>
